import { flatten, filter } from 'lodash';
import localStore from './localStorage';
import { getCountryCode } from './countryCodeUtils';
import { LOGIN, OVERVIEW, EP_EXCHANGE_TOKEN } from '../routes/constants';
import { FINANCE } from './constants';

export const isEmailSame = (sn2Details = {}, linkpassDetails = {}) => {
  if (!sn2Details.email && !linkpassDetails.Email) {
    return true;
  }
  return sn2Details?.email === linkpassDetails?.Email;
};

export const isCountryCodeSame = (sn2Details = {}, linkpassDetails = {}) => {
  if (!sn2Details.mobilePhoneCountryCode && !linkpassDetails.CountryCode) {
    return true;
  }
  return (
    getCountryCode(sn2Details.mobilePhoneCountryCode) ===
    getCountryCode(linkpassDetails.CountryCode)
  );
};

export const isPhoneNumberSame = (sn2Details = {}, linkpassDetails = {}) => {
  if (
    isCountryCodeSame(sn2Details, linkpassDetails) &&
    sn2Details.mobilePhone === linkpassDetails.PhoneNumber
  ) {
    return true;
  }
  return false;
};

export const isDetailsNotMatch = (sn2Details, linkpassDetails) => {
  return (
    !isEmailSame(sn2Details, linkpassDetails) ||
    !isPhoneNumberSame(sn2Details, linkpassDetails)
  );
};

export const logoutUser = () => {
  localStore.setValue('linkpassIDToken', null);
  localStore.setValue('userToken', null);
  localStore.setValue('selectedChild', null);
  localStore.setValue('themeData', null);
  localStore.setValue('schoolID', null);
  window.location.href = LOGIN;
};

export const filterValidPathsForRoleBySideMenu = (
  allRoutes,
  sidemenu,
  userRole
) => {
  let validPaths = sidemenu.map(menu => {
    if (menu.submenu) {
      return menu.submenu.map(sub => sub.path);
    }

    if (menu.path) return menu.path;
  });

  validPaths = flatten(validPaths);

  return filter(allRoutes, route => {
    if (userRole === FINANCE && route.url.includes('enrichment/vendor')) {
      return false;
    }
    const matchesValidPath = validPaths.some(validRoute => {
      return route.url.includes(validRoute);
    });

    return (
      matchesValidPath ||
      route.url === OVERVIEW ||
      route.url === EP_EXCHANGE_TOKEN
    );
  });
};
